import { AccountingLangFactory } from "@bokio/lang";

export function getRecipeNameAndVat(name: string, vatPrecentage: number | undefined, isCompanyVatFree: boolean) {
	const accountingLang = AccountingLangFactory();
	if (isCompanyVatFree) {
		return name;
	}
	if (vatPrecentage !== undefined) {
		return `${name} ${vatPrecentage}% ${accountingLang.RecipeVat}`;
	}
	return name;
}
